import axios from 'axios';

const CONTACT_FORM_ID_SELECTOR = '#contact';

class ContactForm {
    constructor($form) {
        console.debug('Initialise form');
        this.$form = $form;
        this.$submitButton = $form.querySelector('#contact_submit');
        this.$name = $form.querySelector('#form_name');
        this.$email = $form.querySelector('#form_email');
        this.$message = $form.querySelector('#form_message');
        this.$verification = $form.querySelector('#form_nverif');
        this.$resultMessage = $form.querySelector('#contact-form-result');
        this.$csrf = $form.querySelector('input[name=csrfmiddlewaretoken]');
        if (
            this.$submitButton === null || this.$name === null || this.$email === null
            || this.$message === null || this.$resultMessage === null || this.$csrf === null
        ) {
            console.error('Malformed form');
            return;
        }
        this.bindEvents();
    }

    bindEvents() {
        this.$submitButton.addEventListener('click', this.handleSubmit.bind(this));
    }

    handleSubmit(evt) {
        evt.preventDefault();
        const isValid = this.verifyCaptcha(grecaptcha.getResponse())
        this.resetMessage();
        const error = this.validateForm();
        if (!isValid || error) {
            return;
        }
        this.$submitButton.style.enabled = false;
        this.sendData(this.$form.querySelector('form').action);
    }

    verifyCaptcha(token) {
        if (!token) {
            return false;
        }
        return true;
        // let isValid;
        // await Promise.all([axios.post('/api/verify', token).then(response => {
        //     isValid = response === 200 && response.data.success
        // })]);
        // console.log(isValid);
        // return isValid;
    }

    sendData(uri) {
        const data = new FormData();
        data.append('name', this.$name.value);
        data.append('email', this.$email.value);
        data.append('message', this.$message.value);
        data.append('nverif', this.$verification.value);
        data.append('csrfmiddlewaretoken', this.$csrf.value);
        data.append('action', 'mail_contact');
        axios.post(uri, data)
            .then(this.onDataSuccessfullySent.bind(this))
            .catch(this.onError.bind(this));
    }

    resetMessage() {
        this.$resultMessage.innerHTML = '';
        this.$resultMessage.classList.remove('alert-success');
        this.$resultMessage.classList.remove('alert-danger');
        this.$form.querySelectorAll('.invalid-feedback').forEach(item => item.remove());
    }

    onDataSuccessfullySent() {
        this.$resultMessage.innerHTML = 'Message successfully sent!';
        this.$resultMessage.classList.add('alert-success');
        this.$submitButton.style.enabled = true;
    }

    onError(err) {
        console.error(err);
        this.$submitButton.style.enabled = true;
        this.$resultMessage.classList.add('alert-danger');
        this.$resultMessage.innerHTML = 'There was an error sending the message. Please, try again later.';
    }

    validateForm() {
        let error = false;
        if (this.$name.value === "") {
            this.displayError(this.$name, 'Name field is empty');
            error = true;
        } else {
            this.displaySuccess(this.$name);
        }
        if (this.$email.value === "") {
            this.displayError(this.$email, 'E-mail field is empty');
            error = true;
        } else {
            this.displaySuccess(this.$email);
        }
        if (this.$message.value === "") {
            this.displayError(this.$message, 'Message field is empty');
            error = true;
        } else {
            this.displaySuccess(this.$message);
        }
        return error;
    }

    displayError($input, errorMessage) {
        const inputId = $input.id;
        $input.classList.add('is-invalid');
        $input.ariaDescribedby = `${inputId}-feedback`;
        const label = document.createElement('div');
        label.classList.add('invalid-feedback');
        label.id = `${inputId}-feedback`;
        label.innerHTML = errorMessage;
        $input.parentElement.appendChild(label);
    }

    displaySuccess($input) {
        if (!$input.ariaDescribedby || $input.ariaDescribedby === '') {
            return;
        }
        $input.classList.remove('is-invalid');
        $input.ariaDescribedby = '';
    }
}

export default ContactForm;

export {CONTACT_FORM_ID_SELECTOR};
